module.exports = __webpack_public_path__ + "media/images/icons/create_bookmark-9319c9c70da92438880a063e9fcd3a1f.svg";